export default function CalendarPage() {
    return <div className="py-10 text-3xl font-black text-white">Calendrier</div>;
}